/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ToggleJiraButton_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ConfigureJiraSectionInner_organization$ref: FragmentReference;
declare export opaque type ConfigureJiraSectionInner_organization$fragmentType: ConfigureJiraSectionInner_organization$ref;
export type ConfigureJiraSectionInner_organization = {|
  +isJiraEnabled: boolean,
  +onRestrictedPlan: boolean,
  +$fragmentRefs: ToggleJiraButton_organization$ref,
  +$refType: ConfigureJiraSectionInner_organization$ref,
|};
export type ConfigureJiraSectionInner_organization$data = ConfigureJiraSectionInner_organization;
export type ConfigureJiraSectionInner_organization$key = {
  +$data?: ConfigureJiraSectionInner_organization$data,
  +$fragmentRefs: ConfigureJiraSectionInner_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureJiraSectionInner_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJiraEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToggleJiraButton_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'bdfce853b9e437106c825f3ac251ca4f';

module.exports = node;
